<template>
  <div id="tRradeForm">
    <header-nav :content="`${$t('pages_router_003')} / ${ $t('pages_router_005')}`" />
    <div class="common-card-body">
      <a-steps :current="1" size="small" class="apply-step">
        <a-step :title="$t('pages_receive_016')" />
        <a-step :title="$t('pages_receive_017')" />
        <a-step :title="$t('pages_receive_018')" />
      </a-steps>
      <div class="apply-desc">{{ $t('pages_receive_019') }}</div>
      <div v-if="remark" class="error-area flex-align">
        <exclamation-circle-outlined class="ic-error" />
        <span>{{ remark }}</span>
      </div>
      <a-form
        name="applyForm"
        class="ant-round-form va-apply"
        label-align="left"
        :label-col="{span: 7}"
        :model="applyForm"
        :rules="applyRules"
        @finish="applySubmit"
      >
        <a-form-item name="businessChildType" :label="$t('pages_receive_027')">
          <a-select
            v-model:value="applyForm.businessChildType"
            option-filter-prop="label"
            allow-clear
            show-search
            :placeholder="$t('common_text_005') + $t('pages_receive_027')"
            @change="loadReceiveAreas"
          >
            <a-select-option
              v-for="item in tradeCategoryOpts"
              :key="item.code"
              :value="item.code"
              :label="item.name"
            >{{ item.name }}</a-select-option>
          </a-select>
          <a-button style="position: absolute" type="link" @click="$router.back(-1)">{{ $t('pages_receive_023') }}</a-button>
        </a-form-item>
        <a-form-item name="areaCode" :label="$t('pages_receive_025')">
          <a-select
            v-model:value="applyForm.areaCode"
            option-filter-prop="label"
            allow-clear
            show-search
            :placeholder="$t('common_text_005') + $t('pages_receive_025')"
            @change="loadReceiveCurrencies"
          >
            <a-select-option
              v-for="item in areaList"
              :key="item.code"
              :value="item.code"
              :label="item.nameEn + item.name"
            >{{ item.nameEn }} - {{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item name="currency" :label="$t('pages_receive_006')">
          <a-select
            v-model:value="applyForm.currency"
            allow-clear
            show-search
            option-filter-prop="label"
            :placeholder="$t('common_text_005') + $t('pages_receive_006')"
            @change="loadOpenBanks"
          >
            <a-select-option
              v-for="item in curryList"
              :key="item.code"
              :value="item.code"
              :label="`${item.code} - ${item.name}`"
            >
              <img :src="getCountryLogo(item.code)" class="select-img-country">
              <span>{{ item.code }} - {{ item.name }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if:="isAppVa()" name="appName" :label="$t('pages_receive_182')">
          <a-input v-model:value="applyForm.appName" :placeholder="$t('pages_receive_183')" allow-clear />
        </a-form-item>
        <a-form-item v-if:="isAppVa()" name="appUrl" :label="$t('pages_receive_184')">
          <a-input v-model:value="applyForm.appUrl" :placeholder="$t('pages_receive_184')" allow-clear />
        </a-form-item>
        <!-- select app types for isAppVa() true -->
        <a-form-item v-if:="isAppVa()" name="appType" :label="$t('pages_receive_210')">
          <a-select v-model:value="applyForm.appType" allow-clear>
            <a-select-option
              v-for="item in appTypes"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if:="isAppVa()" name="appDeveloperId" :label="$t('pages_receive_211')">
          <a-input v-model:value="applyForm.appDeveloperId" :placeholder="$t('pages_receive_211')" allow-clear />
        </a-form-item>
        <a-form-item v-if:="isGooglePlay()" name="appCloudStoreUri" :label="$t('pages_receive_212')">
          <a-input v-model:value="applyForm.appCloudStoreUri" :placeholder="$t('pages_receive_212')" allow-clear />
        </a-form-item>
        <a-form-item v-if:="isAppStore()" name="appReportAccessToken" :label="$t('pages_receive_213')">
          <a-input v-model:value="applyForm.appReportAccessToken" :placeholder="$t('pages_receive_213')" allow-clear />
        </a-form-item>
        <a-form-item name="tradeSimpleName" :label="$t('pages_receive_005')">
          <a-input v-model:value="applyForm.tradeSimpleName" :placeholder="$t('pages_receive_033')" allow-clear />
        </a-form-item>
        <a-form-item v-if="!isAppVa()" name="acquirer" :label="$t('pages_receive_028')">
          <a-radio-group v-model:value="applyForm.acquirer">
            <a-radio-button value="Y">{{ $t('pages_receive_040') }}</a-radio-button>
            <a-radio-button value="N">{{ $t('pages_receive_041') }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="applyForm.acquirer === 'Y' && !isAppVa()" name="salesWebsite" :label="$t('pages_receive_029')">
          <a-input v-model:value="applyForm.salesWebsite" :placeholder="$t('pages_receive_056')" allow-clear />
        </a-form-item>
        <a-form-item name="busDesDocument" :label="$t('pages_receive_030')" :rules="[{ required: true, message: $t('common_text_007') + $t('pages_receive_030') }]">
          <upload-auto
            ref="uploadRef"
            v-model:file-content="applyForm.busDesDocument"
            accept=".jpg,.png,.jepg,.pdf,.bmp,.zip,.rar"
            list-type="picture"
            :explain="$t('pages_receive_038')"
            :max-count="10"
          />
        </a-form-item>
        <a-form-item name="holderId" :label="$t('pages_receive_166')">
          <div class="flex-align">
            <a-select
              v-model:value="applyForm.holderId"
              allow-clear
              show-search
              :placeholder="$t('common_text_005') + $t('pages_receive_166')"
              @change="loadOpenBanks"
            >
              <a-select-option
                v-for="item in holders"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              >{{ item.name }}</a-select-option>
            </a-select>
            <a-button
              type="primary"
              shape="circle"
              size="small"
              style="margin-left: 12px; font-weight: 600"
              @click="$router.push('/receive/holder_edit')"
            >+</a-button>
          </div>
        </a-form-item>
        <div v-if="openBankOpts.length !== 0">
          <a-form-item name="tradeAccountName" :label="$t('pages_receive_057')">
            <a-radio-group v-model:value="applyForm.tradeAccountName" button-style="solid" @change="e => accountChange(e.target.value)">
              <a-radio-button
                v-for="item in openBankOpts"
                :key="item.name"
                :value="item.name"
                style="margin-bottom: 12px"
              >{{ item.name }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item name="lsType" :label="$t('pages_receive_127')" style="margin-top: -12px">
            <a-radio-group v-model:value="applyForm.lsType" button-style="solid" @change="e => lsTypeChange(e.target.value)">
              <a-radio-button v-if="lsTypeOpts.includes('S')" key="swift" value="S" class="lsType-radio">
                <div class="title">{{ $t('pages_receive_167') }}</div>
                <div class="desc"><a-tooltip :title="$t('pages_receive_168')">{{ $t('pages_receive_168') }}</a-tooltip></div>
              </a-radio-button>
              <a-radio-button v-if="lsTypeOpts.includes('L')" key="local" value="L" class="lsType-radio">
                <div class="title">{{ $t('pages_receive_169') }}</div>
                <div class="desc"><a-tooltip :title="$t('pages_receive_170')">{{ $t('pages_receive_170') }}</a-tooltip></div>
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-if="vaList.length !== 0" name="abilityId" :label="$t('pages_receive_058')">
            <a-radio-group v-model:value="applyForm.abilityId" style="width: 900px" @change="e => openBankChange(e.target.value)">
              <a-radio
                v-for="va in vaList"
                :key="va.abilityId"
                :value="va.abilityId"
              >{{ va.banKName }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item v-if="vaInfo && vaInfo.receiveCurrency" :wrapper-col="{ offset: 7 }">
            <a-card class="va-content" hoverable>
              <div style="display: flex">
                <span style="white-space: nowrap">{{ $t('pages_receive_059') }}</span>
                <div class="country-list">
                  <div
                    v-for="country in vaInfo.receiveCurrency.split(' ').splice(0, 14)"
                    :key="country"
                    class="country flex-align"
                  >
                    <img :src="getCountryLogo(country)">
                    <span>{{ country }}</span>
                    <div
                      v-if="vaInfo.receiveCurrency.split(' ').length > 14 && index === 13"
                      style="white-space: nowrap; margin-left: 3px"
                    >{{ $t('pages_receive_060') }}{{ vaInfo.receiveCurrency.split(' ').length }}{{ $t('pages_receive_061') }}</div>
                  </div>
                </div>
              </div>
              <P>{{ $t('pages_receive_062') }}<span style="margin-left: 24px">{{ vaInfo.receiveArea }}</span></P>
              <P style="margin-top: 10px">{{ $t('pages_receive_063') }}
                <span style="margin-left: 24px">
                  {{ $t('pages_receive_064') }}<span style="font-size: 13px; font-weight: 600">{{ vaInfo.lsContent }}</span>{{ $t('pages_receive_065') }}
                </span>
              </P>
              <P style="margin-top: 10px">{{ $t('pages_receive_066') }}
                <span style="margin-left: 24px">{{ vaInfo.time }}</span>
              </P>
            </a-card>
          </a-form-item>
        </div>
        <a-form-item :wrapper-col="{ offset: 7 }">
          <a-button
            :disabled="!isAgree"
            :loading="loading"
            html-type="submit"
            type="primary"
            shape="round"
            class="apply-btn"
          >{{ $t('common_text_002') }}</a-button>
          <a-button
            shape="round"
            style="margin-left: 18px"
            class="apply-btn"
            type="primary"
            ghost
            @click="$router.back(-1)"
          >{{ $t('common_text_003') }}</a-button>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 7 }" style="margin-top: -12px">
          <a-checkbox v-model:checked="isAgree">
            <span>{{ $t('pages_receive_014') }}</span>
            <span class="use-terms" @click="showTerms">{{ $t('pages_receive_015') }}</span>
          </a-checkbox>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs, createVNode } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { _receive } from '@/api/index'
import i18n from '@/locale/index'
import { Modal, message } from 'ant-design-vue'
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import HeaderNav from '@/components/header-nav'
import UploadAuto from '@/components/upload-auto'
import { getCountryLogo } from '@/util'
import { getTradeStatusName } from '@/util'
export default {
  name: 'TRradeForm',
  components: {
    'header-nav': HeaderNav,
    'upload-auto': UploadAuto
  },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const uploadRef = ref(null)
    const state = reactive({
      businessType: route.query.businessType,
      remark: '',
      isAgree: false,
      loading: false,
      areaList: [],
      curryList: [],
      checked: true,
      appTypes: [
        { label: i18n.global.t('pages_receive_185'), value: '01' },
        { label: i18n.global.t('pages_receive_186'), value: '02' },
        { label: i18n.global.t('pages_receive_187'), value: '03' },
        { label: i18n.global.t('pages_receive_188'), value: '04' },
        { label: i18n.global.t('pages_receive_189'), value: '05' },
        { label: i18n.global.t('pages_receive_190'), value: '06' },
        { label: i18n.global.t('pages_receive_191'), value: '07' },
        { label: i18n.global.t('pages_receive_192'), value: '08' },
        { label: i18n.global.t('pages_receive_193'), value: '09' },
        { label: i18n.global.t('pages_receive_194'), value: '10' },
        { label: i18n.global.t('pages_receive_195'), value: '11' },
        { label: i18n.global.t('pages_receive_196'), value: '12' },
        { label: i18n.global.t('pages_receive_197'), value: '13' },
        { label: i18n.global.t('pages_receive_198'), value: '14' },
        { label: i18n.global.t('pages_receive_199'), value: '15' },
        { label: i18n.global.t('pages_receive_200'), value: '16' },
        { label: i18n.global.t('pages_receive_201'), value: '17' },
        { label: i18n.global.t('pages_receive_202'), value: '18' },
        { label: i18n.global.t('pages_receive_203'), value: '19' },
        { label: i18n.global.t('pages_receive_204'), value: '20' },
        { label: i18n.global.t('pages_receive_205'), value: '21' },
        { label: i18n.global.t('pages_receive_206'), value: '22' }
      ],
      applyForm: {
        id: route.query.id || '',
        businessChildType: null,
        areaCode: null,
        currency: null,
        tradeSimpleName: '',
        salesWebsite: '',
        tradeAccountName: '',
        isSameName: '',
        bankCode: '',
        abilityId: '',
        lsType: '',
        acquirer: 'Y',
        busDesDocument: '',
        holderId: null
      },
      applyRules: {
        businessChildType: [{ required: true }],
        areaCode: [{ required: true }],
        currency: [{ required: true }],
        tradeSimpleName: [{ required: true }],
        acquirer: [{ required: true }],
        salesWebsite: [{ required: true }],
        tradeAccountName: [{ required: true }],
        abilityId: [{ required: true }],
        lsType: [{ required: true }],
        holderId: [{ required: true }],
        appName: [{ required: true }],
        appUrl: [{ required: true }],
        appType: [{ required: true }],
        appDeveloperId: [{ required: true }],
        appReportAccessToken: [{ required: true }],
        appCloudStoreUri: [{ required: true }]
      },
      tradeCategoryOpts: [],
      openBankOpts: [],
      vaList: [],
      lsTypeOpts: [],
      sOpts: [],
      lOpts: [],
      holders: [],
      vaInfo: {}
    })
    const showTerms = (e) => {
      e.preventDefault()
      Modal.info({
        title: i18n.global.t('pages_receive_015'),
        icon: null,
        width: 588,
        content: createVNode('div', {
          style: { marginTop: '12px' }
        }, [
          createVNode('div', {}, i18n.global.t('pages_receive_048')),
          createVNode('div', {}, i18n.global.t('pages_receive_049')),
          createVNode('div', {}, i18n.global.t('pages_receive_050'))
        ])
      })
    }
    const applySubmit = async () => {
      state.loading = true
      const data = Object.assign({}, state.applyForm, {
        businessType: state.businessType
      })
      const res = await _receive.applyToVa(data)
      if (res.data.succ) {
        router.replace('apply_success')
      } else if (res.data.resCode === '130041') {
        Modal.confirm({
          title: i18n.global.t('common_text_015'),
          content: i18n.global.t('pages_holder_059'),
          width: 500,
          icon: createVNode(CloseCircleOutlined, { style: { color: '#ff4d4f' }}),
          okText: i18n.global.t('pages_holder_060'),
          onOk: () => {
            router.push({
              path: '/receive/holder_edit',
              query: { id: state.applyForm.holderId, status: '40' }
            })
          }
        })
      } else {
        message.error(res.data.resMsg)
      }
      state.loading = false
    }
    const loadTradeCategory = async () => {
      const res = await _receive.getBusinessChildType({ businessType: state.businessType })
      if (res.data.succ) {
        state.tradeCategoryOpts = res.data.data.map(item => {
          return Object.assign({}, {
            code: item,
            name: getTradeStatusName(item, 'receiveBusinessChildType')
          })
        })
      }
    }
    const loadReceiveAreas = async (businessChildType, record) => {
      if (typeof record !== 'boolean') {
        state.applyForm.areaCode = null
        state.applyForm.currency = null
        state.applyForm.tradeAccountName = ''
        state.applyForm.isSameName = ''
        state.applyForm.bankCode = ''
        state.applyForm.abilityId = ''
        state.applyForm.lsType = ''
        state.curryList = []
        state.openBankOpts = []
      }
      state.areaList = []
      const { businessType } = state
      const res = await _receive.getReceiveAreas({ businessType, businessChildType })
      if (res.data.succ) {
        state.areaList = res.data.data
      }
    }
    const loadReceiveCurrencies = async (areaCode, record) => {
      if (typeof record !== 'boolean') {
        state.applyForm.currency = null
        state.applyForm.tradeAccountName = ''
        state.applyForm.isSameName = ''
        state.applyForm.bankCode = ''
        state.applyForm.abilityId = ''
        state.applyForm.lsType = ''
        state.openBankOpts = []
      }
      state.curryList = []
      if (areaCode) {
        const { businessType } = state
        const { businessChildType } = state.applyForm
        const res = await _receive.getReceiveCurrencys({ businessType, businessChildType, areaCode })
        if (res.data.succ) {
          state.curryList = res.data.data
        }
      }
    }
    const loadHolderDetails = async () => {
      const res = await _receive.queryHolderList()
      if (res.data.succ) {
        state.holders = res.data.data
        if (!state.applyForm.holderId && res.data.data[0]) state.applyForm.holderId = res.data.data[0].code
      }
    }
    const loadOpenBanks = async (e, record) => {
      if (typeof record !== 'boolean') {
        state.applyForm.tradeAccountName = ''
        state.applyForm.isSameName = ''
        state.applyForm.bankCode = ''
        state.applyForm.abilityId = ''
        state.applyForm.lsType = ''
      }
      state.openBankOpts = []
      const { businessType } = state
      const { businessChildType, areaCode, holderId, currency } = state.applyForm
      const query = {
        businessType,
        businessChildType,
        areaCode,
        currency,
        holderId
      }
      if (!query.currency || !query.holderId) return
      const res = await _receive.getBankOfDeposit(query)
      const openBankOpts = []
      if (res.data.succ) {
        for (const item of res.data.data) {
          const findIndex = openBankOpts.findIndex(opt => opt.name === item.name)
          if (findIndex !== -1) openBankOpts[findIndex].list.push(item)
          else openBankOpts.push({ name: item.name, list: [item] })
        }
        for (let i = 0; i < openBankOpts.length; i++) {
          const sOpts = openBankOpts[i].list.filter(item => item.lsType === 'S')
          const lOpts = openBankOpts[i].list.filter(item => item.lsType === 'L')
          const lsTypeOpts = []
          if (sOpts.length !== 0) lsTypeOpts.push('S')
          if (lOpts.length !== 0) lsTypeOpts.push('L')
          openBankOpts[i].lsTypeOpts = lsTypeOpts
          openBankOpts[i].sOpts = sOpts
          openBankOpts[i].lOpts = lOpts
        }
        state.openBankOpts = openBankOpts.sort((a, b) => {
          if (a.name.indexOf('OTT') !== -1 && b.name.indexOf('OTT') === -1) return -1
          if (b.name.indexOf('OTT') !== -1 && a.name.indexOf('OTT') === -1) return 1
          return 0
        })
        if (state.openBankOpts.length > 0) {
          if (!state.applyForm.tradeAccountName) {
            state.applyForm.tradeAccountName = state.openBankOpts[0].name
            accountChange(state.applyForm.tradeAccountName)
          } else {
            const vaMaterial = state.openBankOpts.find((item) => {
              return item.name === state.applyForm.tradeAccountName
            })
            state.lsTypeOpts = vaMaterial.lsTypeOpts
            state.sOpts = vaMaterial.sOpts
            state.lOpts = vaMaterial.lOpts
            if (!state.applyForm.lsType) {
              if (state.lsTypeOpts.length === 1) state.applyForm.lsType = state.lsTypeOpts[0]
              else return
            }
            if (state.applyForm.lsType === 'S') state.vaList = state.sOpts
            else state.vaList = state.lOpts
            state.vaInfo = state.vaList.find(va => va.abilityId === state.applyForm.abilityId)
          }
        }
      }
    }
    const accountChange = (bankName) => {
      const vaMaterial = state.openBankOpts.find(item => item.name === bankName)
      state.lsTypeOpts = vaMaterial.lsTypeOpts
      state.sOpts = vaMaterial.sOpts
      state.lOpts = vaMaterial.lOpts
      lsTypeChange(state.lsTypeOpts[0])
    }
    const lsTypeChange = (lsType) => {
      if (lsType === 'S') state.vaList = state.sOpts
      else state.vaList = state.lOpts
      state.vaInfo = state.vaList[0]
      state.applyForm.tradeAccountName = state.vaInfo.name
      state.applyForm.bankCode = state.vaInfo.bankCode
      state.applyForm.isSameName = state.vaInfo.isSameName
      state.applyForm.abilityId = state.vaInfo.abilityId
      state.applyForm.lsType = state.vaInfo.lsType
    }
    const openBankChange = (abilityId) => {
      const vaInfo = state.vaList.find(item => item.abilityId === abilityId)
      state.vaInfo = vaInfo
      state.applyForm.bankCode = vaInfo.bankCode
      state.applyForm.isSameName = vaInfo.isSameName
      state.applyForm.abilityId = vaInfo.abilityId
      state.applyForm.lsType = vaInfo.lsType
    }
    const loadAccountDetail = async (id) => {
      const res = await _receive.geVaDetail({ id })
      if (res.data.succ) {
        const { data } = res.data
        state.remark = data.remark
        state.applyForm.businessChildType = data.businessChildType
        state.applyForm.areaCode = data.areaCode
        state.applyForm.currency = data.oneCurrency
        state.applyForm.salesWebsite = data.saleWebsite
        state.applyForm.tradeSimpleName = data.simpleName
        state.applyForm.busDesDocument = data.busDesDocument
        state.applyForm.tradeAccountName = data.tradeAccountName
        state.applyForm.bankCode = data.bankCode
        state.applyForm.isSameName = data.isSameName
        state.applyForm.abilityId = data.abilityId
        state.applyForm.lsType = data.lsType
        state.applyForm.acquirer = data.saleWebsite ? 'Y' : 'N'
        state.applyForm.holderId = data.holderId ? String(data.holderId) : null
        if (data.busDesDocument) uploadRef.value.fileListRefresh(data.busDesDocuments)
        loadReceiveAreas(state.applyForm.businessChildType, true)
        loadReceiveCurrencies(state.applyForm.areaCode, true)
        loadOpenBanks(state.applyForm.currency, true)
        loadHolderDetails()
      }
    }
    const isAppVa = () => {
      return state.applyForm.businessChildType === '50' || state.applyForm.businessChildType === '51'
    }
    const isGooglePlay = () => {
      return state.applyForm.businessChildType === '50'
    }
    const isAppStore = () => {
      return state.applyForm.businessChildType === '51'
    }

    if (state.applyForm.id) loadAccountDetail(state.applyForm.id)
    else loadHolderDetails()
    loadTradeCategory(state.businessType, state.businessChildType)

    return {
      uploadRef,
      getCountryLogo,
      applySubmit,
      showTerms,
      lsTypeChange,
      accountChange,
      openBankChange,
      loadTradeCategory,
      loadReceiveAreas,
      loadReceiveCurrencies,
      loadOpenBanks,
      isAppVa,
      isGooglePlay,
      isAppStore,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less">
#tRradeForm {
  .common-card-body {
    padding: 18px 36px;
  }
  .apply-desc {
    font-size: 12px;
    color: #666;
    margin-top: 18px;
    text-align: left;
  }
  .error-area {
    width: 600px;
    padding: 12px 24px;
    border-radius: 48px;
    color: @error-color;
    background: #fef0f0;
    margin-top: 24px;
    text-align: left;
    word-break: break-word;
    .ic-error {
      font-size: 28px;
      margin-right: 12px;
    }
  }
  .va-apply {
    width: 600px;
    margin-top: 24px;
    text-align: left;
    .va-content {
      font-size: 12px;
      border-radius: 10px;
      display: inline-block;
      width: 728px;
      .country-list {
        display: flex;
        flex-wrap: wrap;
        margin-left: 24px;
        width: 548px;
        .country {
          flex: 0 0 14%;
          margin-bottom: 12px;
          img {
            width: 25px;
            height: 18px;
          }
          span {
            margin-left: 8px;
          }
        }
      }
    }
    .ant-form-item {
      padding-bottom: 12px;
      .lsType-radio {
        height: auto;
        width: 210px;
        text-align: center;
        .title {
          font-size: 16px;
          font-weight: 600;
        }
        .desc {
          margin-top: -5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .apply-btn {
        min-width: 138px;
      }
      .use-terms {
        color: @main-color;
        margin-left: 3px;
      }
    }
  }
}
</style>

